// qr-landing.js
// works with: qr and shopify pages

(function () {
  const ENDPOINT_URL = "https://us-central1-fetch-this-45a3c.cloudfunctions.net/writeMyRepChat";

  // ============================================================
  // 1) WRITE-MY-REP CHAT (optional – only if page has #secChat)
  // ============================================================
  const secChat = document.getElementById("secChat");

  if (secChat) {
    const el = {
      // inputs
      issue: document.getElementById("issue"),
      tone: document.getElementById("tone"),
      position: document.getElementById("position"),
      contentType: document.getElementById("contentType"),
      notes: document.getElementById("notes"),
      start: document.getElementById("startBtn"),

      // sections
      secInputs: document.getElementById("secInputs"),
      secChat,
      secPreview: document.getElementById("secPreview"),

      // chat (scoped to #secChat)
      chat: secChat.querySelector("#chat"),
      status: secChat.querySelector("#status"),
      typing: secChat.querySelector("#typing"),
      chatInput: secChat.querySelector("#chatInput"),
      send: secChat.querySelector("#sendBtn"),
      draft: secChat.querySelector("#draftBtn"),
      approve: secChat.querySelector("#approveBtn"),

      // preview/actions
      preview: document.getElementById("preview"),
      chip: document.getElementById("approvedChip"),
      edit: document.getElementById("editBtn"),
      actionBtns: Array.from(document.querySelectorAll("[data-action]")),
    };

// topic pill buttons
	  const hotIssueChips = document.querySelectorAll(".wmr-issue-chip");

		hotIssueChips.forEach(chip => {
		  chip.addEventListener("click", () => {
			const value = chip.dataset.issue;
			if (el.issue) {
			  el.issue.value = "";        // clear any previous selection
			  el.issue.value = value;     // this will only “just work” if you add matching <option> values later
			}

			hotIssueChips.forEach(c => c.classList.remove("wmr-issue-selected"));
			chip.classList.add("wmr-issue-selected");
		  });
		});

	  
    // state
    let messages = [];
    let lastDraftText = "";

    // Helper to set Issue Card selections in WMR overlay

    function setSelectIfMatches(selectEl, value) {
      if (!selectEl || !value) return;
      const v = value.trim();
      const options = Array.from(selectEl.options || []);
      const match = options.find(o =>
        o.value === v || o.textContent.trim() === v
      );
      if (match) selectEl.value = match.value;
    }

    function setStatus(text, kind = "info") {
      if (!el.status) return;
      el.status.textContent = text || "";
      if (text && text.trim()) {
        el.status.style.display = "block";
      } else {
        el.status.style.display = "none";
      }
      el.status.className = (kind === "error") ? "status error" : "status";
    }

    function escapeHTML(s) {
      return s.replace(/[&<>"']/g, m => (
        { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]
      ));
    }

    function addBubble(role, text) {
      // drop placeholder if there
      const placeholder = el.chat.querySelector("p.muted");
      if (placeholder) placeholder.remove();

      const d = document.createElement("div");
      d.className = "bubble " + (role === "user" ? "user" : "assistant");
      d.innerHTML = (role === "user" ? "<b>You:</b> " : "<b>AI:</b> ") + escapeHTML(text);
      el.chat.appendChild(d);
      el.chat.scrollTop = el.chat.scrollHeight;
    }

    let typingTimer = null;
    function setTyping(on) {
      if (!el.typing) return;
      if (on) {
        el.typing.classList.add("on");
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => { }, 700);
      } else {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => { el.typing.classList.remove("on"); }, 150);
      }
    }

    async function callAI(mode, userInput = "") {
      const statusText =
        mode === "draft" ? "Drafting…" :
          (userInput && userInput.trim() ? "AI is thinking…" : "Thinking…");
      setStatus(statusText);
      setTyping(true);

      // push user turn
      if (userInput) {
        messages.push({ role: "user", content: userInput });
        addBubble("user", userInput);
        if (el.chatInput) el.chatInput.value = "";
      } else if (mode === "draft" && messages.length === 0) {
        setStatus("Start the conversation first.", "error");
        setTyping(false);
        return;
      }

      const payload = {
        issue: (el.issue?.value || "").trim(),
        tone: (el.tone?.value || "").trim(),
        position: (el.position?.value || "").trim(),
        contentType: (el.contentType?.value || "").trim() || "letter",
        notes: (el.notes?.value || "").trim(),
        mode,
        messages,
      };

      try {
        const res = await fetch(ENDPOINT_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({ error: "Unknown API error" }));
          throw new Error(`HTTP ${res.status}: ${errData.error || "Server error"}`);
        }


        const data = await res.json();
        let aiResponseText = "";

        if (mode === "chat") {
          aiResponseText = (data.reply || "").trim();
          if (!aiResponseText) {
            aiResponseText = "Hmm, I seem to have lost my thought. Can you rephrase that?";
          }
          messages.push({ role: "assistant", content: aiResponseText });
          addBubble("assistant", aiResponseText);

        } else {
          const draftText = (data.draft || "").trim();
          lastDraftText = draftText;
          const bubbleText = "Draft complete:\n\n" + draftText;
          messages.push({ role: "assistant", content: draftText });
          addBubble("assistant", bubbleText);

          // enable approve
          el.approve?.removeAttribute("disabled");

          // show preview
          if (el.secPreview) {
            el.secPreview.classList.remove("hidden");
            el.secPreview.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        setStatus("");
      } catch (err) {
        console.error(err);
        setStatus("There was a problem: " + err.message, "error");
      } finally {
        setTyping(false);
      }
    }

    function resetConversationUI() {
      messages = [];
      lastDraftText = "";

      const statusNode = el.status;
      el.chat.innerHTML = "";
      if (statusNode) el.chat.appendChild(statusNode);

      const ph = document.createElement("p");
      ph.className = "muted";
      ph.style.margin = "0";
      ph.textContent = "Your conversation will appear here.";
      el.chat.appendChild(ph);

      if (el.preview) {
        el.preview.innerHTML =
          "<p class='muted' style='margin:0'>Approved draft will appear here.</p>";
      }
      if (el.chip) el.chip.style.display = "none";

      el.secChat.classList.remove("hidden");
      el.secChat.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    // Start button – generic entry (no card)
    el.start?.addEventListener("click", () => {
      resetConversationUI();
      callAI("chat", "");
    });

    // ISSUE CARDS – pre-fill fields and auto-start chat
    const issueCards = document.querySelectorAll(".issue-card");

    function applyCardToForm(cardEl) {
      if (!cardEl) return;
      const ds = cardEl.dataset;

      // map card values into the form
      setSelectIfMatches(el.issue, ds.issue);
      setSelectIfMatches(el.position, ds.position);
      setSelectIfMatches(el.tone, ds.tone);
      setSelectIfMatches(el.contentType, ds.contentType);

      const hint = ds.messageHint || "";
      if (hint && el.notes && !el.notes.value.trim()) {
        el.notes.value = hint;
      }
    }

    issueCards.forEach(card => {
      card.addEventListener("click", () => {
        applyCardToForm(card);
        resetConversationUI();

        const labelEl = card.querySelector(".issue-card-title");
        const label =
          (labelEl && labelEl.textContent.trim()) || card.dataset.label || "";

        if (label) {
          setStatus(`You’re writing about: ${label}`);
        }

        // Initial AI turn based on pre-filled values
        callAI("chat", "");
      });
    });


    // Send
    el.send?.addEventListener("click", () => {
      const t = el.chatInput.value.trim();
      if (!t) return;
      callAI("chat", t);
    });
    el.chatInput?.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey && el.chatInput.value.trim()) {
        e.preventDefault();
        el.send.click();
      }
    });

    // Draft
    el.draft?.addEventListener("click", () => {
      callAI("draft");
    });

    // Approve
    el.approve?.addEventListener("click", () => {
      const text = (lastDraftText || "").trim();
      if (!text) {
        setStatus("No draft to approve yet. Click Draft first.", "error");
        return;
      }
      if (el.preview) el.preview.innerText = text;
      if (el.chip) el.chip.style.display = "inline-block";
      if (el.secPreview) el.secPreview.classList.remove("hidden");
      setStatus("Approved.");
    });

    // Edit
    el.edit?.addEventListener("click", () => {
      el.secChat.scrollIntoView({ behavior: "smooth", block: "start" });
      el.chatInput.value = "I need a change. ";
      el.chatInput.focus();
      setStatus("Type your change request in the chat box.", "info");
    });

	// Hook output actions (copy/export) to current preview/status
const overlay = document.getElementById('wmrOverlay'); // scope-safe if you add WMR in multiple places later
if (window.WMRExport) {
  window.WMRExport.bind({
    container: overlay || document,
    getText: () => (el.preview?.innerText || ""),
    setStatus
  });
}
} // close: if (secChat) {   ← add this line



  // ============================================================
  // 2) FIND MY OFFICIALS (standalone; runs even w/o chat)
  // ============================================================
  const officialsInput   = document.getElementById("officialsInput");
  const officialsBtn     = document.getElementById("officialsBtn");
  const officialsStatus  = document.getElementById("officialsStatus");
  const officialsOutput  = document.getElementById("officialsOutput");

  if (officialsInput && officialsBtn && officialsStatus && officialsOutput) {
    // show/hide the 5 boxes
    function showLayout(which) {
      ["1","2","3","4","5"].forEach(n => {
        const box = document.getElementById("officialsLayout" + n);
        if (!box) return;
        if (n === which) box.classList.remove("hidden");
        else box.classList.add("hidden");
      });
    }

    function setOfficialsStatus(msg, isError) {
      officialsStatus.textContent = msg || "";
      officialsStatus.style.color = isError ? "#b00020" : "inherit";
    }

    // click: change layout
    officialsOutput.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-layout]");
      if (!btn) return;
      showLayout(btn.dataset.layout);
    });

    // parse 1 AI line -> normalised object
    function parseOfficialLine(line) {
      // AI will usually do "Name — Title — Party — State — contact"
      // but sometimes "Name - Title" so be a little flexible
      const parts = line.split(/—|-/).map(p => p.trim()).filter(Boolean);
      const obj = {
        raw: line,
        name: parts[0] || line,
        title: parts[1] || "",
        party: parts[2] || "",
        state: parts[3] || "",
        contact: parts[4] || ""
      };
      return obj;
    }

    // render ALL layouts from one AI text
    function renderOfficials(rawText, placeText) {
      const lines = rawText.split(/\n+/).map(l => l.trim()).filter(Boolean);
      const officials = lines.map(parseOfficialLine);

      // LAYOUT 1 – simple vertical cards
      const lay1 = document.getElementById("officialsLayout1");
      if (lay1) {
        lay1.innerHTML = "";
        officials.forEach(off => {
          const div = document.createElement("div");
          div.className = "person";
          div.innerHTML = `
            <div><strong>${off.name}</strong></div>
            <div class="small muted">
              ${[off.title, off.party, off.state].filter(Boolean).join(" · ")}
            </div>
            ${off.contact ? `<div class="small"><a href="${off.contact}" target="_blank" rel="noreferrer">Contact / website</a></div>` : ""}
          `;
          lay1.appendChild(div);
        });
      }

      // LAYOUT 2 – radio choose
      const lay2 = document.getElementById("officialsLayout2");
      const lay2body = document.getElementById("officialsChoices");
      if (lay2 && lay2body) {
        lay2body.innerHTML = "";
        officials.forEach((off, idx) => {
          const label = document.createElement("label");
          label.className = "row";
          label.style.alignItems = "flex-start";
          label.style.gap = ".5rem";
          label.innerHTML = `
            <input type="radio" name="officialChoice" value="${idx}" ${idx === 0 ? "checked" : ""} />
            <div>
              <div><strong>${off.name}</strong></div>
              <div class="small muted">${[off.title, off.party, off.state].filter(Boolean).join(" · ")}</div>
              ${off.contact ? `<div class="small"><a href="${off.contact}" target="_blank">Contact form</a></div>` : ""}
            </div>
          `;
          lay2body.appendChild(label);
        });
      }

      // LAYOUT 3 – list w/ mini thumb + heading
      const lay3 = document.getElementById("officialsLayout3");
      const lay3list = document.getElementById("officialsList3");
      const lay3place = document.getElementById("officialsPlaceText");
      if (lay3 && lay3list) {
        if (lay3place && placeText) lay3place.textContent = placeText;
        lay3list.innerHTML = "";
        officials.forEach(off => {
          const row = document.createElement("div");
          row.className = "person row";
          row.style.gap = ".75rem";
          row.style.alignItems = "flex-start";
          row.innerHTML = `
            <div style="width:34px;height:34px;border:1px solid var(--line);border-radius:8px;background:#f3f4f6;"></div>
            <div>
              <div><strong>${off.name}</strong></div>
              <div class="small muted">${[off.title, off.party, off.state].filter(Boolean).join(" · ")}</div>
              ${off.contact ? `<div class="small"><a href="${off.contact}" target="_blank">Contact</a></div>` : ""}
            </div>
          `;
          lay3list.appendChild(row);
        });
      }

      // LAYOUT 4 – horizontal cards (carousel-ish)
      const lay4 = document.getElementById("officialsRow4");
      if (lay4) {
        lay4.innerHTML = "";
        officials.forEach(off => {
          const card = document.createElement("div");
          card.className = "person";
          card.style.minWidth = "180px";
          card.innerHTML = `
            <div><strong>${off.name}</strong></div>
            <div class="small muted">${[off.title, off.party, off.state].filter(Boolean).join(" · ")}</div>
            ${off.contact ? `<div class="small"><a href="${off.contact}" target="_blank">Contact form</a></div>` : ""}
            <label class="small"><input type="checkbox" /> Include</label>
          `;
          lay4.appendChild(card);
        });
      }

      // LAYOUT 5 – compact table-like
      const lay5 = document.getElementById("officialsTable5");
      if (lay5) {
        lay5.innerHTML = "";
        officials.forEach(off => {
          const row = document.createElement("div");
          row.className = "row";
          row.style.gap = "1rem";
          row.style.alignItems = "flex-start";
          row.style.borderBottom = "1px solid var(--line)";
          row.style.padding = ".5rem 0";
          row.innerHTML = `
            <div style="flex:0 0 180px;">
              <strong>${off.name}</strong><br>
              <span class="small muted">${[off.title, off.party, off.state].filter(Boolean).join(" · ")}</span>
            </div>
            <div class="small">
              ${off.contact ? `<a href="${off.contact}" target="_blank">Website contact form</a><br>` : ""}
              <span class="muted small">Add social media here</span>
            </div>
          `;
          lay5.appendChild(row);
        });
      }

      // show first by default
      showLayout("1");
    }

    // main click
    officialsBtn.addEventListener("click", async () => {
      const place = (officialsInput.value || "").trim();
      if (!place) {
        setOfficialsStatus("Enter a ZIP or city/state first.", true);
        return;
      }

      setOfficialsStatus("Looking up officials…", false);

      try {
        const res = await fetch(ENDPOINT_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            issue: "",
            tone: "",
            position: "",
            contentType: "officials-list",
            mode: "chat",
            messages: [
              {
                role: "user",
                content:
                  `I am a citizen in "${place}". Using web search, return the CURRENT federal and state elected officials who represent this location. ` +
                  `Return one official per line, formatted as: "Name — Title — Party — State — official contact/website URL if available". ` +
                  `Do not ask me follow-up questions.`
              }
            ]
          })
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        const text = (data.reply || data.draft || "").trim();
        if (!text) {
          setOfficialsStatus("No officials returned. Try a full address.", true);
          return;
        }

        renderOfficials(text, place);
        setOfficialsStatus("Done.");
      } catch (err) {
        console.error(err);
        setOfficialsStatus("Lookup failed. Try again.", true);
      }
    });
  }

})();
